import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';
import { qualityApi, type QualityHazardItem } from '../services/quality';

function BackIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="m15 18-6-6 6-6" />
    </svg>
  );
}

export function QualityHazardsPrintPage() {
  const toast = useToast();
  const [items, setItems] = useState<QualityHazardItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    qualityApi.hazards()
      .then((data) => setItems(data.items))
      .catch(() => toast.error('Kunde inte ladda skrivvyn för faroanalys'))
      .finally(() => setLoading(false));
  }, [toast]);

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-start justify-between gap-4 print:hidden">
        <div className="space-y-3">
          <Link to="/quality/hazards" className="inline-flex items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800 shadow-sm transition hover:border-slate-400 hover:bg-slate-50">
            <BackIcon />
            <span>Tillbaka</span>
          </Link>
          <div className="space-y-2">
            <h1 className="text-[26px] font-semibold tracking-[-0.03em] text-slate-950 md:text-[30px]">Faroanalys, skrivvy</h1>
            <p className="max-w-3xl text-base leading-7 text-slate-600">
              Ren tabell för utskrift eller PDF-export via webbläsaren.
            </p>
          </div>
        </div>

        <button type="button" className="btn btn-secondary rounded-2xl px-4 py-2" onClick={() => window.print()}>
          Skriv ut
        </button>
      </div>

      <div className="overflow-hidden rounded-[28px] border border-slate-300 bg-white shadow-[0_10px_30px_rgba(15,23,42,0.05)] print:rounded-none print:border-0 print:shadow-none">
        <div className="overflow-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-white">
              <tr className="border-b border-slate-300 text-left text-slate-900">
                <th className="px-4 py-3 font-semibold">Kapitel</th>
                <th className="px-4 py-3 font-semibold">Processsteg</th>
                <th className="px-4 py-3 font-semibold">Fara</th>
                <th className="px-4 py-3 font-semibold">Förebyggande åtgärd</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="px-4 py-8 text-center text-slate-500">Laddar faroanalys...</td>
                </tr>
              ) : (
                items.map((item) => (
                  <tr key={item.id} className="border-b border-slate-200 align-top last:border-b-0">
                    <td className="px-4 py-3">{item.chapter}</td>
                    <td className="px-4 py-3 whitespace-pre-line">{item.processStep}</td>
                    <td className="px-4 py-3 whitespace-pre-line">{item.hazard}</td>
                    <td className="px-4 py-3 whitespace-pre-line">{item.action}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
